export default __webpack_public_path__ + "static/media/chart.7396c476.svg";